<template>
  <div class="pages">
    <el-row :gutter="0">
      <el-col>
        <el-card class="box-card">
          <div style="margin-bottom: 0.25rem" class="justify-between">
            <span class="title">汇总数量</span>
            <div class="justify-between">
              <el-tabs
                class="mini tabsRight"
                v-model="authentication"
                @tab-click="countHandleClick"
              >
                <el-tab-pane label="总计" name="1"></el-tab-pane>
                <el-tab-pane label="今日" name="2"></el-tab-pane>
                <el-tab-pane label="本周" name="3"></el-tab-pane>
              </el-tabs>
              <el-select
                clearable
                v-model="schoolValue"
                @change="countHandleClick"
                style="margin-left: 25px"
                size="mini"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="flex justify-between">
            <template v-for="(val, idx) in dataList">
              <el-col :key="idx" class="backimg" :class="'backimg' + idx">
                <div class="section" :class="'back' + idx">
                  <span class="text_10">{{ val.number }}</span>

                  <div class="flex-row group_8">
                    <span class="text_9">{{ val.name }}</span>
                  </div>
                </div>
              </el-col>
            </template>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="30" style="margin-top: 0.25rem">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="justify-between">
            <span class="title">阅读统计</span>
            <div>
              <el-select
                clearable
                v-model="schoolValue2"
                @change="getArticleReadStatistic"
                style="margin-right: 25px"
                size="mini"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                @change="getArticleReadStatistic"
                style="width: 2.5rem"
                v-model="readDateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div id="read" style="width: 100%; height: 4.7rem"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div class="justify-between">
            <span class="title">分享统计</span>
            <div>
              <el-select
                clearable
                v-model="schoolValue3"
                @change="getArticleShareStatistic"
                style="margin-right: 25px"
                size="mini"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-date-picker
                style="width: 2.5rem"
                v-model="shareDateValue"
                @change="getArticleShareStatistic"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div id="share" style="width: 100%; height: 4.7rem"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row style="margin-top: 0.25rem">
      <el-card class="box-card">
        <div class="justify-between">
          <span class="title">热度排行</span>
          <div class="flex">
            <el-tabs
              style="width: 2rem"
              class="mini tabsRight"
              v-model="ranking"
              @tab-click="rankHandleClick"
            >
              <el-tab-pane label="总计" name="1"></el-tab-pane>
              <el-tab-pane label="今日" name="2"></el-tab-pane>
              <el-tab-pane label="本周" name="3"></el-tab-pane>
            </el-tabs>
            <el-select
              clearable
              v-model="schoolValue4"
              @change="changeArticleHotStatistic"
              style="margin-right: 25px"
              size="mini"
              placeholder="请选择学校"
            >
              <el-option
                v-for="item in schoolList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-date-picker
              style="width: 2.5rem"
              v-model="rankDateValue"
              @change="changeArticleHotStatistic"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
        </div>
        <el-table :data="tableData" class="header-blue" style="width: 100%">
          <el-table-column
            show-overflow-tooltip
            align="center"
            label="文章名称"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.title }}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            label="阅读数量"
          >
            <template slot-scope="scope">
              <div class="flex justify-center">
                <div class="progressBar">
                  <div
                    class="border borderColor1"
                    :style="'width:' + scope.row.readCount + '%;'"
                  ></div>
                </div>
                <span style="margin-left: 10px">{{ scope.row.readCount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            label="获赞数量"
          >
            <template slot-scope="scope">
              <div class="flex justify-center">
                <div class="progressBar">
                  <div
                    class="border borderColor2"
                    :style="'width:' + scope.row.thumbUpCount + '%;'"
                  ></div>
                </div>
                <span style="margin-left: 10px">{{
                  scope.row.thumbUpCount
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            label="分享数量"
          >
            <template slot-scope="scope">
              <div class="flex justify-center">
                <div class="progressBar">
                  <div
                    class="border borderColor3"
                    :style="'width:' + scope.row.forwardCount + '%;'"
                  ></div>
                </div>
                <span style="margin-left: 10px">{{
                  scope.row.forwardCount
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="center"
            label="收藏数量"
          >
            <template slot-scope="scope">
              <div class="flex justify-center">
                <div class="progressBar">
                  <div
                    class="border borderColor4"
                    :style="'width:' + scope.row.collectCount + '%;'"
                  ></div>
                </div>
                <span style="margin-left: 10px">{{
                  scope.row.collectCount
                }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pages justify-end">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="currentSize"
            layout="  prev, pager, next,  sizes, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //学校
      schoolValue: "",
      schoolValue2: "",
      schoolValue3: "",
      schoolValue4: "",
      maxNumbe: 1000,
      //分享排名数据
      tableData: [],
      //分享排名时间
      rankDateValue: ["", ""],
      dataList: [
        {
          name: "内容发布数",
          number: "0",
          state: true,
        },
        {
          name: "内容阅读总量",
          number: "0",
          state: false,
        },
        {
          name: "内容分享总量",
          number: "0",
          state: true,
        },
        {
          name: "内容获赞总数",
          number: "0",
          state: false,
        },
      ],
      //学校列表
      schoolList: [],
      //排名选项卡
      ranking: "1",
      //总数选项卡
      authentication: "1",
      //汇总数量信息
      articleSummaryStatisticInfo: {},
      //阅读统计
      srticleReadStatisticInfo: {},
      //阅读时间
      readDateValue: ["", ""],
      //阅读时间 echarts数据、
      readEchartDate: [],
      readEchartValue: [],
      //分享时间
      shareDateValue: ["", ""],
      //分享时间 echarts数据、
      shareEchartDate: [],
      shareEchartValue: [],
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
    };
  },
  created() {
    this.getArticleSummaryStatistic();
    this.getArticleReadStatistic();
    this.getArticleShareStatistic();
    this.getArticleHotStatistic();
    this.getSchoolList();
  },
  mounted() {},
  methods: {
    countHandleClick() {
      this.getArticleSummaryStatistic(this.authentication);
    },
    rankHandleClick() {
      this.currentPage = 1;
      this.rankDateValue = null;
      this.getArticleHotStatistic(this.ranking);
    },
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取统计数量
    getArticleSummaryStatistic(type = 1) {
      let params = {
        summarytype: type,
        schoolid: this.schoolValue,
      };

      let url = this.$dataConver.getUrl(
        "/admin/ArticleStatistic/GetArticleSummaryStatistic",
        params
      );

      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.articleSummaryStatisticInfo = res.data;
          this.dataList[0].number =
            this.articleSummaryStatisticInfo.creationCount;
          this.dataList[1].number = this.articleSummaryStatisticInfo.readCount;
          this.dataList[2].number =
            this.articleSummaryStatisticInfo.forwardCount;
          this.dataList[3].number =
            this.articleSummaryStatisticInfo.thumbUpCount;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取阅读统计
    getArticleReadStatistic() {
      var params = {
        readstart: this.readDateValue == null ? "" : this.readDateValue[0],
        readend: this.readDateValue == null ? "" : this.readDateValue[1],
        schoolid: this.schoolValue2,
      };
      var url = this.$dataConver.getUrl(
        "/admin/ArticleStatistic/GetArticleReadStatistic",
        params
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.srticleReadStatisticInfo = res.data;
          this.readEchartDate = [];
          this.readEchartValue = [];
          this.srticleReadStatisticInfo.forEach((element) => {
            this.readEchartDate.push(element.creationTime);
            this.readEchartValue.push(element.count);
          });
          setTimeout(() => {
            this.readEchartsInit();
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //获取分享统计
    getArticleShareStatistic() {
      let params = {
        sharestart: this.shareDateValue == null ? "" : this.shareDateValue[0],
        shareend: this.shareDateValue == null ? "" : this.shareDateValue[1],
        schoolid: this.schoolValue3,
      };
      let url = this.$dataConver.getUrl(
        "/admin/ArticleStatistic/GetArticleShareStatistic",
        params
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.srticleReadStatisticInfo = res.data;
          this.shareEchartDate = [];
          this.shareEchartValue = [];
          this.srticleReadStatisticInfo.forEach((element) => {
            this.shareEchartDate.push(element.creationTime);
            this.shareEchartValue.push(element.count);
          });
          setTimeout(() => {
            this.shareEchartsInit();
          }, 20);
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //分享排名日期切换
    changeArticleHotStatistic() {
      this.currentPage = 1;
      this.ranking = 0;
      this.getArticleHotStatistic(this.ranking);
    },
    //获取分享排名
    getArticleHotStatistic(hottype = 1, PageIndex = 1, PageSize = 10) {
      var params = {
        hottype: hottype,
        PageIndex: PageIndex,
        PageSize: PageSize,
        DateBegin: this.rankDateValue == null ? "" : this.rankDateValue[0],
        DateEnd: this.rankDateValue == null ? "" : this.rankDateValue[1],
        schoolid: this.schoolValue4,
      };
      var url = this.$dataConver.getUrl(
        "/admin/ArticleStatistic/GetArticleHotStatistic",
        params
      );
      this.$api.get(url).then((res) => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    readEchartsInit() {
      var chartDom = document.getElementById("read");
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.readEchartDate,
        },
        tooltip: {
          trigger: "axis",
          formatter: "阅读量：{c}",
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        grid: {
          top: "10%",
          left: "0%",
          right: "2%",
          bottom: "0%",
          containLabel: true,
        },
        series: [
          {
            data: this.readEchartValue,
            type: "line",
            areaStyle: {},
          },
        ],
        color: ["#68b3ff"],
      };
      option && myChart.setOption(option);
    },
    shareEchartsInit() {
      var chartDom = document.getElementById("share");
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.shareEchartDate,
        },
        tooltip: {
          trigger: "axis",
          formatter: "分享量：{c}",
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        grid: {
          top: "10%",
          left: "0%",
          right: "2%",
          bottom: "0%",
          containLabel: true,
        },
        series: [
          {
            data: this.shareEchartValue,
            type: "line",
            areaStyle: {},
          },
        ],
        color: ["#68b3ff"],
      };

      option && myChart.setOption(option);
    },
    //翻页
    handleSizeChange(val) {
      this.currentPage = 1;
      this.currentSize = val;
      this.getArticleHotStatistic(
        this.ranking,
        this.currentPage,
        this.currentSize
      );
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getArticleHotStatistic(
        this.ranking,
        this.currentPage,
        this.currentSize
      );
    },
  },
};
</script>
<style lang="scss" scoped>
>>> {
  .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-date-editor--timerange.el-input__inner {
    width: 100%;
  }
  .tabsRight .el-tabs__nav {
    float: left;
  }
}
.section {
  padding: 0.2rem;
  border-radius: 0.04rem;
  .group_8 {
    line-height: 0.3rem;
    padding: 0.05rem 0;
    .text_9 {
      margin-top: 0.02rem;
      font-size: 0.26rem;
      color: #fff;
    }
    .image_6 {
      flex-shrink: 0;
      width: 0.21rem;
      height: 0.32rem;
    }
    .image_8 {
      margin-left: 0.05rem;
    }
  }
  .text_10 {
    color: rgb(255, 255, 255);
    font-size: 0.48rem;
    font-family: Microsoft YaHei;
    font-weight: 700;
    line-height: 1;
  }
}
.back0 {
  background-image: linear-gradient(
    135deg,
    rgb(255, 139, 135) 0%,
    rgb(247, 192, 149) 100%
  );
}
.back1 {
  background-image: linear-gradient(
    135deg,
    rgb(66, 220, 197) 0%,
    rgb(9, 195, 159) 100%
  );
}
.back2 {
  background-image: linear-gradient(
    135deg,
    rgb(52, 214, 255) 0%,
    rgb(53, 158, 252) 100%
  );
}
.back3 {
  background-image: linear-gradient(
    135deg,
    rgb(74, 165, 253) 0%,
    rgb(73, 112, 254) 100%
  );
}

.backimg0 {
  background-image: url("../../assets/images/backimg0.png");
}
.backimg1 {
  background-image: url("../../assets/images/backimg1.png");
}
.backimg2 {
  background-image: url("../../assets/images/backimg2.png");
}
.backimg3 {
  background-image: url("../../assets/images/backimg3.png");
}
.backimg {
  background-repeat: no-repeat;
  padding-bottom: 38px;
  background-size: 90% 100%;
  background-position: bottom;
  width: 23%;
}
.progressBar {
  height: 0.18rem;
  width: 80%;
  background: #eeeeee;
  border-radius: 0.5rem;
  min-height: 0.18rem !important;
  margin: 0.06rem 0.2rem;
}
.progressBar .border {
  height: 0.18rem;
  border-radius: 0.5rem;
  min-height: 0.18rem !important;
}
.progressBar .borderColor1 {
  background-image: linear-gradient(90deg, #f46772 0%, #fda777 100%);
}
.progressBar .borderColor2 {
  background-image: linear-gradient(
    -90deg,
    #84f5de 0%,
    #56e8f2 50%,
    #4cc5f8 100%
  );
}
.progressBar .borderColor3 {
  background-image: linear-gradient(
    -90deg,
    rgba(247, 203, 107, 1) 0%,
    #fba980 100%
  );
}
.progressBar .borderColor4 {
  background-image: linear-gradient(90deg, #5eb0b2 0%, #a9e2c1 100%);
}
.header-blue {
  margin-top: 0.2rem;
}
.header-blue >>> .el-table__header tr th {
  background: #4b91ff;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/view/contentManagement/dataStatistics.vue